<template>
  <el-dialog
    id="editDialog"
    :title="editInfo && editInfo.id ? '修改商品分类' : '新增商品分类'"
    :visible="visible"
    append-to-body
    modal-append-to-body
    width="500px"
    @close="$emit('close', false)"
  >
    <el-form
      :model="editInfo"
      label-position="right"
      label-width="100px"
      ref="editFormRef"
      :rules="{
        name: $ruleUtil.name('名称'),
        remark: $ruleUtil.simple({
          fieldName: '备注',
          required: false,
          max: 50,
        }),
      }"
      v-if="editInfo"
    >
      <el-form-item label="名称" prop="name">
        <el-input
          v-model="editInfo.name"
          placeholder="请输入商品分类名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="默认标识" prop="defaultMark">
        <el-tooltip
          slot="label"
          content="设置此商品分类是否是默认分类，默认分类将会在选择页面自动带出"
          placement="top"
        >
          <span>
            <i class="el-icon-question"></i>
            默认标识
          </span>
        </el-tooltip>
        <el-radio-group v-model="editInfo.defaultMark">
          <el-radio :label="true">
            <span v-fmtype="'success'">默认</span>
          </el-radio>
          <el-radio :label="false">
            <span v-fmtype="'warning'">非默认</span>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6 }"
          v-model="editInfo.remark"
          placeholder="请输入备注信息"
        ></el-input>
      </el-form-item>
      <el-form-item label="冻结状态" prop="frozen">
        <el-radio-group v-model="editInfo.frozen">
          <el-radio :label="false">
            <span v-fmtype="'success'">未冻结</span>
          </el-radio>
          <el-radio :label="true">
            <span v-fmtype="'danger'">已冻结</span>
          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close', false)">取 消</el-button>
      <el-button type="primary" @click="edit">
        {{ editInfo && editInfo.id ? "修 改" : "新 增" }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "Rterpv2WebCommodityCategoryAddNewDialog",
  props: {
    id: {
      type: String,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.initData();
          }, 50);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      editInfo: {},
    };
  },

  mounted() {},

  methods: {
    async initData() {
      this.editInfo = {
        name: null,
        defaultMark: false,
        remark: null,
        frozen: false,
      };
      if (this.id) {
        let resultRes = await this.$api.commodityCategory_findById(this.id, {
          showLoading: true,
          loadingParam: {
            target: "#editDialog > *",
            lock: true,
          },
        });
        if (resultRes && resultRes.success) {
          this.editInfo = resultRes.data;
        }
      }
    },

    async edit() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.editInfo.id
          ? await this.$api.commodityCategory_update(this.editInfo, {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "修改中...",
              },
            })
          : await this.$api.commodityCategory_addNew(this.editInfo, {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "新增中...",
              },
            });
        if (requestRes && requestRes.success) {
          this.$emit("close", true);
        }
      });
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/CommodityCategoryAddNewDialog.vue